module.exports = __webpack_public_path__ + "images/stickers/taco-money@2x.f0130dd81ed48f6e4626.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-money@2x.png
// module id = FXJF
// module chunks = 2